export default __webpack_public_path__ + "static/media/operativemodelBox.1458adde.png";